import { defineComponent as _defineComponent } from 'vue';
import { BModal } from "bootstrap-vue";
import { reactive, ref } from "vue";
import WorkflowCard from "./WorkflowCard.vue";
import WorkflowRename from "./WorkflowRename.vue";
import WorkflowPublished from "@/components/Workflow/Published/WorkflowPublished.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowCardList',
    props: {
        workflows: null,
        gridView: { type: Boolean },
        hideRuns: { type: Boolean },
        filterable: { type: Boolean },
        publishedView: { type: Boolean },
        editorView: { type: Boolean },
        currentWorkflowId: null
    },
    emits: ["tagClick", "refreshList", "updateFilter", "insertWorkflow", "insertWorkflowSteps"],
    setup(__props, { emit }) {
        const props = __props;
        const modalOptions = reactive({
            rename: {
                id: "",
                name: "",
            },
            preview: {
                id: "",
            },
        });
        const showRename = ref(false);
        function onRenameClose() {
            showRename.value = false;
            emit("refreshList", true);
        }
        function onRename(id, name) {
            modalOptions.rename.id = id;
            modalOptions.rename.name = name;
            showRename.value = true;
        }
        const showPreview = ref(false);
        function onPreview(id) {
            modalOptions.preview.id = id;
            showPreview.value = true;
        }
        // TODO: clean-up types, as soon as better Workflow type is available
        function onInsert(workflow) {
            emit("insertWorkflow", workflow.latest_workflow_id, workflow.name);
        }
        function onInsertSteps(workflow) {
            emit("insertWorkflowSteps", workflow.id, workflow.number_of_steps);
        }
        return { __sfc: true, props, emit, modalOptions, showRename, onRenameClose, onRename, showPreview, onPreview, onInsert, onInsertSteps, BModal, WorkflowCard, WorkflowRename, WorkflowPublished };
    }
});
